import useDealer from "hooks/useDealer";
import DealerSettings from "views/Dealers/Tabs/DealerMiscellaneous";

// core components
import PageLayout from "layouts/PageLayout";

import { EDIT } from "const";

export default function DealerSettingsView({ ...otherProps }) {
    const dealer = useDealer();

    return (
        <PageLayout {...otherProps}>
            <DealerSettings dlid={dealer.id} form={EDIT} />
        </PageLayout>
    );
}
